import { create } from 'zustand';

interface StrakModalStore {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useStreakModalStore = create<StrakModalStore>(set => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false })
}));
